import React from "react";
// import Common Banner
import CommonBanner from "../../component/Common/CommonBanner";
// import TourDetails
import HajjPackageDetails from "../../component/HajjPackageDetails";
import { ImageConstants } from "../../assets/img/ImageConstants";
import { Helmet } from "react-helmet-async";

const TourDetails = () => {
  const handleWhatsAppClick = (packageType) => {
    const whatsappURL = `https://wa.me/923449992333?text=Hey,%20I%20want%20to%20know%20more%20about%20the%20${packageType}%20Package.`;
    window.open(whatsappURL, "_blank");
  };
  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>
          Hajj Packages 2025 | Premium & Economy Packages | Polani Travels
        </title>
        <meta
          name="description"
          content="Book your Hajj 2025 packages with Polani Travels. All-inclusive packages with 5-star hotels, VIP transport, dedicated guides, and Ziyarat services. Licensed by Ministry of Religious Affairs Pakistan."
        />
        <meta
          name="keywords"
          content="hajj packages 2025, hajj booking, hajj from pakistan, economy hajj package, VIP hajj package, hajj guide, makkah hotel booking, madina hotel booking, hajj visa service, polani travels hajj"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://polani-2c215.web.app/hajj-packages"
        />
        <meta
          property="og:title"
          content="Hajj Packages 2025 | Premium & Economy Options | Polani Travels"
        />
        <meta
          property="og:description"
          content="Discover our comprehensive Hajj 2025 packages including 5-star accommodations, VIP transport, experienced guides, and complete Ziyarat services. Ministry approved Hajj operator serving pilgrims since 1990."
        />
        <meta
          property="og:image"
          content="https://polani-2c215.web.app/static/media/hajj-p1.b3b5049431c01609ac97.jpg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="polani-2c215.web.app" />
        <meta
          property="twitter:url"
          content="https://polani-2c215.web.app/hajj-packages"
        />
        <meta
          name="twitter:title"
          content="Hajj Packages 2025 | Licensed Hajj Operator | Polani Travels"
        />
        <meta
          name="twitter:description"
          content="Book your Hajj 2025 journey with Pakistan's trusted Hajj operator. Featuring luxury hotels near Haram, dedicated transport, experienced guides, and complete pilgrimage support."
        />
        <meta
          name="twitter:image"
          content="https://polani-2c215.web.app/static/media/hajj-p1.b3b5049431c01609ac97.jpg"
        />

        {/* Additional SEO Tags */}
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://polani-2c215.web.app/hajj-packages"
        />
        <meta name="author" content="Polani Travels" />
      </Helmet>
      <CommonBanner
        heading="Package-5 (Medina After Hajj) 14 Days"
        img={ImageConstants.hajjbanner}
        pagination="Package Details"
      />
      <section id="tour_details_main" className="section_padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="tour_details_leftside_wrapper">
                <div className="tour_details_heading_wrapper">
                  <div className="tour_details_top_heading">
                    <h2>Package-5 (Medina After Hajj) "14 Days" </h2>
                    <h5>
                      <i className="fas fa-map-marker-alt"></i> Makkah, Madina
                    </h5>
                  </div>
                  <div className="tour_details_top_heading_right">
                    <h4>Excellent</h4>
                    <h6>Teantative Package</h6>
                    <p>(1214 reviewes)</p>
                  </div>
                </div>
                <div className="tour_details_top_bottom">
                  <div className="toru_details_top_bottom_item">
                    <div className="tour_details_top_bottom_icon">
                      <i className="fas fa-clock"></i>
                    </div>
                    <div className="tour_details_top_bottom_text">
                      <h5>Duration</h5>
                      <p>14 days</p>
                    </div>
                  </div>
                  <div className="toru_details_top_bottom_item">
                    <div className="tour_details_top_bottom_icon">
                      <i className="fas fa-plane"></i>
                    </div>
                    <div className="tour_details_top_bottom_text">
                      <h5>Air Ticket</h5>
                      <p>Return</p>
                    </div>
                  </div>
                  <div className="toru_details_top_bottom_item">
                    <div className="tour_details_top_bottom_icon">
                      <i className="fas fa-file-pdf"></i>
                    </div>
                    <div className="tour_details_top_bottom_text">
                      <h5>Package </h5>
                      <p>05</p>
                    </div>
                  </div>
                  <div className="toru_details_top_bottom_item">
                    <div className="tour_details_top_bottom_icon">
                      <i className="fas fa-map-marked"></i>
                    </div>
                    <div className="tour_details_top_bottom_text">
                      <h5>Maktab</h5>
                      <p>B Zone 1 </p>
                    </div>
                  </div>
                </div>
                <div className="tour_details_img_wrapper">
                  <div className="tour_react_big">
                    <img
                      className="w-100"
                      src={ImageConstants.hajjP5MaktabB}
                      alt="img"
                    />
                  </div>
                </div>
                <div className="tour_details_boxed">
                  <h3 className="heading_theme">Overview</h3>
                  <div className="tour_details_boxed_inner">
                    {/* <p>
                      At Polani Webiye, we specialize in providing seamless
                      travel solutions, including Hajj and Hajj packages,
                      religious travel, and corporate tours. Our services are
                      designed to cater to both individual and group travelers,
                      ensuring comfort and convenience every step of the way.
                    </p>
                    <p>
                      Our Hajj packages offer an unforgettable spiritual journey
                      to Makkah and Madina. We also provide worldwide travel
                      packages for leisure and business, catering to clients who
                      seek excellence and professionalism in their travel
                      arrangements.
                    </p> */}
                    <ul>
                      <li>
                        <i className="fas fa-circle"></i>04 DAYS AZIZIA 31 MAY - 03 JUNE 2025 (AZIZIA BUILDING) ON FULL BOARD MEALS
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>05 DAYS HAJJ DAYS 04 – 08 JUNE (MINA + ARAFAT + MUZDALFAH) ON FULL BOARD MEALS IN MINA AND ARAFAT 
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>01 DAY AZIZIA 09 JUNE 2025 (AZIZIA BUILDING) ON FULL BOARD MEALS
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>04 DAYS MEDINAH 10 – 12/13 JUNE 2025 (TAIBA FRONT OR SIMILAR) ON FULL BOARD ASIAN BUFFET
                      </li>
                     
                    </ul>
                  </div>
                </div>
                {/* <div className="tour_details_boxed">
                  <h3 className="heading_theme">Itinerary</h3>
                  <div className="tour_details_boxed_inner">
                    <div className="accordion" id="accordionExample">
                      <div className="accordion_flex_area">
                        <div className="accordion_left_side">
                          <h5>Day 1</h5>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne">
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              Arrival in Makkah
                            </button>
                          </h2>
                          <div
                            id="collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <ul>
                                <li>
                                  <i className="fas fa-circle"></i>Arrival at
                                  King Abdulaziz International Airport
                                </li>
                                <li>
                                  <i className="fas fa-circle"></i>Check-in at a
                                  4-star hotel near Haram
                                </li>
                                <li>
                                  <i className="fas fa-circle"></i>Initial Hajj
                                  rites and spiritual orientation
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="accordion_flex_area">
                        <div className="accordion_left_side">
                          <h5>Day 2</h5>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingTwo">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                            >
                              Pilgrimage Activities
                            </button>
                          </h2>
                          <div
                            id="collapseTwo"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <ul>
                                <li>
                                  <i className="fas fa-circle"></i>Visit sacred
                                  sites around Makkah
                                </li>
                                <li>
                                  <i className="fas fa-circle"></i>Group prayer
                                  sessions and spiritual discussions
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="accordion_flex_area">
                        <div className="accordion_left_side">
                          <h5>Day 3</h5>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne">
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              Arrival in Makkah
                            </button>
                          </h2>
                          <div
                            id="collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <ul>
                                <li>
                                  <i className="fas fa-circle"></i>Arrival at
                                  King Abdulaziz International Airport
                                </li>
                                <li>
                                  <i className="fas fa-circle"></i>Check-in at a
                                  4-star hotel near Haram
                                </li>
                                <li>
                                  <i className="fas fa-circle"></i>Initial Hajj
                                  rites and spiritual orientation
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="accordion_flex_area">
                        <div className="accordion_left_side">
                          <h5>Day 4</h5>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne">
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              Arrival in Makkah
                            </button>
                          </h2>
                          <div
                            id="collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <ul>
                                <li>
                                  <i className="fas fa-circle"></i>Arrival at
                                  King Abdulaziz International Airport
                                </li>
                                <li>
                                  <i className="fas fa-circle"></i>Check-in at a
                                  4-star hotel near Haram
                                </li>
                                <li>
                                  <i className="fas fa-circle"></i>Initial Hajj
                                  rites and spiritual orientation
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="tour_details_boxed">
                  <h3 className="heading_theme">Included/Excluded</h3>
                  <div className="tour_details_boxed_inner">
                    <p>
                      "Our Hajj and corporate packages are inclusive of all
                      essentials to ensure a hassle-free experience for our
                      clients. We provide comfortable accommodations,
                      transportation, and guided tours to make the journey
                      seamless and memorable. Our dedicated team takes care of
                      every detail, from visa processing to itinerary planning,
                      so you can focus on your spiritual journey or business
                      needs. Whether it's a religious pilgrimage or a corporate
                      trip, we prioritize your convenience and satisfaction
                      every step of the way.
                    </p>
                    <ul>
                      <li>
                        <i className="fas fa-circle"></i>Return air tickets
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>Accommodation in
                        premium hotels
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>Private and group
                        transportation options
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>All necessary permits
                        and documentation
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>Dedicated travel
                        support team
                      </li>
                    </ul>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="col-lg-4">
              <div className="tour_details_right_sidebar_wrapper">
                <div className="tour_detail_right_sidebar">
                  <div className="tour_details_right_boxed">
                    <div className="tour_details_right_box_heading">
                      <h3>Package Info</h3>
                    </div>
                    <div className="valid_date_area">
                      <div className="valid_date_area_one">
                        <h5>Valid from</h5>
                        <p>31 May 2025</p>
                      </div>
                      <div className="valid_date_area_one">
                        <h5>Valid till</h5>
                        <p>12 June 2025</p>
                      </div>
                    </div>
                    <div className="tour_package_details_bar_list">
                      <h5>Package details</h5>
                      <ul>
                        <li>
                          <i className="fas fa-circle"></i>
                          Return Air Ticket from Karachi
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>
                          Makkah Hotel Near to Haram
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>
                          VIP Luxury Buses
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>
                          24 Hours Hot and Cold Berera
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>
                          Ziarat in Makkah & Madina
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>
                          Hajj Kits with Gift Bags
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>
                          24/7 Meet & Greet Assistance
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>
                          Maktab BClosest To Jamarat
                        </li>
                      </ul>
                    </div>
                    {/* <div className="tour_package_details_bar_price">
              <h5>Price</h5>
              <div className="tour_package_bar_price">
                <h6>
                  <del>$ 35,500</del>
                </h6>
                <h3>
                  $ 30,500 <sub>/Per serson</sub>{" "}
                </h3>
              </div>
            </div> */}
                  </div>
                  {/* <div className="tour_select_offer_bar_bottom">
            <button
              className="btn btn_theme btn_md w-100"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
            >
              Select offer
            </button>
          </div> */}
                </div>
                <div className="tour_detail_right_sidebar">
                  <div className="tour_details_right_boxed">
                    <div className="tour_details_right_box_heading">
                      <h3>Double </h3>
                    </div>
                    {/* <div className="valid_date_area">
              <div className="valid_date_area_one">
                <h5>Valid from</h5>
                <p>01 Feb 2022</p>
              </div>
              <div className="valid_date_area_one">
                <h5>Valid till</h5>
                <p>15 Feb 2022</p>
              </div>
            </div> */}
                    {/* <div className="tour_package_details_bar_list">
                      <h5>Package details</h5>
                      <ul>
                        <li>
                          <i className="fas fa-circle"></i>Buffet breakfast as
                          per the Itinerary
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>Visit eight villages
                          showcasing Polynesian culture
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>Complimentary Camel
                          safari, Bonfire,
                        </li>
                      </ul>
                    </div> */}
                    <div className="tour_package_details_bar_price">
                      <h5>Price</h5>
                      <div className="tour_package_bar_price">
                        {/* <h6>
                  <del>$ 13,270</del>
                </h6> */}
                        <h3>
                          PKR 2,080,000   <sub>/Per serson</sub>{" "}
                        </h3>
                        <h3>
                          $ 7,510 <sub>/Per serson</sub>{" "}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="tour_select_offer_bar_bottom">
                  <button
      className="btn btn_theme btn_md w-100"
      onClick={() => handleWhatsAppClick("Double")}
    >
      Select offer
    </button>
                  </div>
                </div>

                <div className="tour_detail_right_sidebar">
                  <div className="tour_details_right_boxed">
                    <div className="tour_details_right_box_heading">
                      <h3>Tripple </h3>
                    </div>
                    {/* <div className="valid_date_area">
              <div className="valid_date_area_one">
                <h5>Valid from</h5>
                <p>01 Feb 2022</p>
              </div>
              <div className="valid_date_area_one">
                <h5>Valid till</h5>
                <p>15 Feb 2022</p>
              </div>
            </div> */}
                    {/* <div className="tour_package_details_bar_list">
                      <h5>Package details</h5>
                      <ul>
                        <li>
                          <i className="fas fa-circle"></i>Buffet breakfast as
                          per the Itinerary
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>Visit eight villages
                          showcasing Polynesian culture
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>Complimentary Camel
                          safari, Bonfire,
                        </li>
                      </ul>
                    </div> */}
                    <div className="tour_package_details_bar_price">
                      <h5>Price</h5>
                      <div className="tour_package_bar_price">
                        {/* <h6>
                  <del>$ 13,270</del>
                </h6> */}
                        <h3>
                          PKR 2,010,000  <sub>/Per serson</sub>{" "}
                        </h3>
                        <h3>
                          $ 7,230 <sub>/Per serson</sub>{" "}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="tour_select_offer_bar_bottom">
                  <button
      className="btn btn_theme btn_md w-100"
      onClick={() => handleWhatsAppClick("Tripple")}
    >
      Select offer
    </button>
                  </div>
                </div>
                <div className="tour_detail_right_sidebar">
                  <div className="tour_details_right_boxed">
                    <div className="tour_details_right_box_heading">
                      <h3>Quad </h3>
                    </div>
                    {/* <div className="valid_date_area">
              <div className="valid_date_area_one">
                <h5>Valid from</h5>
                <p>01 Feb 2022</p>
              </div>
              <div className="valid_date_area_one">
                <h5>Valid till</h5>
                <p>15 Feb 2022</p>
              </div>
            </div> */}
                    {/* <div className="tour_package_details_bar_list">
                      <h5>Package details</h5>
                      <ul>
                        <li>
                          <i className="fas fa-circle"></i>Buffet breakfast as
                          per the Itinerary
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>Visit eight villages
                          showcasing Polynesian culture
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>Complimentary Camel
                          safari, Bonfire,
                        </li>
                      </ul>
                    </div> */}
                    <div className="tour_package_details_bar_price">
                      <h5>Price</h5>
                      <div className="tour_package_bar_price">
                        {/* <h6>
                  <del>$ 13,270</del>
                </h6> */}
                        <h3>
                          PKR 1,960,000  <sub>/Per serson</sub>{" "}
                        </h3>
                        <h3>
                          $ 7,075 <sub>/Per serson</sub>{" "}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="tour_select_offer_bar_bottom">
                  <button
      className="btn btn_theme btn_md w-100"
      onClick={() => handleWhatsAppClick("Quad")}
    >
      Select offer
    </button>
                  </div>
                </div>
                <div className="tour_detail_right_sidebar">
                  <div className="tour_details_right_boxed">
                    <div className="tour_details_right_box_heading">
                      <h3>Why choose us</h3>
                    </div>

                    <div className="tour_package_details_bar_list first_child_padding_none">
                      <ul>
                        <li>
                          <i className="fas fa-circle"></i>Buffet breakfast as
                          per the Itinerary
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>Visit eight villages
                          showcasing Polynesian culture
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>Complimentary Camel
                          safari, Bonfire,
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>All toll tax,
                          parking, fuel, and driver allowances
                        </li>
                        <li>
                          <i className="fas fa-circle"></i>Comfortable and
                          hygienic vehicle
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br></br>
        {/* <ReviewArea /> */}
        {/* <CustomerReview /> */}
      </section>
    </>
  );
};

export default TourDetails;
